import React, { useCallback } from 'react';
import * as S from './styles';
import styled, { css } from 'styled-components';
import { layout, colorUtils } from '@prisjakt/ui-base';
import { TitleSmallText } from '@prisjakt/ui/text/variants';

import { PopularSearch } from 'src/types';
import { useHistory } from 'react-router-dom';

const DefaultComponent = styled.div(
  p => css`
    margin: ${layout.measurements.spacingTiny};
    background: ${p.theme.colors.yellove300};
    border-radius: 100px;
    padding: ${layout.measurements.spacingTiny};
    padding-right: ${layout.measurements.spacingNormal};
    padding-left: ${layout.measurements.spacingNormal};

    &:hover {
      background-color: ${colorUtils.shadeColor(
        p.theme.colors.yellove300,
        -10
      )};
      cursor: pointer;
    }
  `
);

type Props = {
  customComponent?: React.ElementType;
  onClose?: () => void;
  popularSearches: (PopularSearch | null)[];
};

export const PopularSearches = (props: Props) => {
  const { customComponent, onClose, popularSearches } = props;
  const Component = customComponent || DefaultComponent;
  const history = useHistory();

  const handleOnClick = useCallback(
    query => {
      history.push(`/search/?search=${query}`);
      if (onClose) onClose();
    },
    [history, onClose]
  );

  return (
    <S.Wrapper>
      {popularSearches
        ? popularSearches.map(search => (
            <Component
              key={search?.query}
              onClick={() => handleOnClick(search?.query)}
            >
              <TitleSmallText>{search?.query}</TitleSmallText>
            </Component>
          ))
        : null}
    </S.Wrapper>
  );
};
